import React, { useMemo } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import Divider from '@material-ui/core/Divider';
import SidebarMenuListItem from 'layout-components/SidebarMenu/SidebarMenuListItem';
import headerNavLinks from 'layout-components/HeaderMenuSimple/headerNavLinks';
import { extractItemsByUserPlan } from 'global/GlobalActions';
import { useDispatch } from 'react-redux';
import { setWatchlistDialog } from 'reducers/Watchlist';

const SidebarMainMenuLinksForMobile = () => {
  const dispatch = useDispatch();
  const allowedHeaderNavLinks = useMemo(() => extractItemsByUserPlan(null, headerNavLinks), []);

  const onWatchlistClick = () => {
    dispatch(setWatchlistDialog(true));
  };

  return (
    <List style={{ padding: 0 }}>
      {allowedHeaderNavLinks.map((navItem, i) => {
        return <SidebarMenuListItem key={i} navItem={navItem} disabled={false} />;
      })}
      <ListItem style={{ padding: '2px 0 1px' }} disableGutters>
        <Button
          onClick={onWatchlistClick}
          style={{ fontWeight: 500, borderRadius: 0, width: '100%', justifyContent: 'flex-start' }}>
          {<LocalActivityIcon style={{ marginRight: '16px' }} />}
          Watchlist
        </Button>
      </ListItem>
      <Divider />
    </List>
  );
};

export default SidebarMainMenuLinksForMobile;
